import { render, staticRenderFns } from "./TrademarkObjectionToUsStatus.vue?vue&type=template&id=31bfc326&"
import script from "./TrademarkObjectionToUsStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports